export default {
  'listings.title': 'List, launch and grow your digital asset',
  'listings.desc': 'We provide full-service solutions for successful execution of digital asset projects. We have a global exposure.',
  'listings.li_1': 'No hidden fees.',
  'listings.li_2': 'No hacking and security risks.',
  'listings.li_3': 'MM Fund requirements & fee accounts provided',
  'listings.Apply': 'Apply for listing now',
  'listings.recentList.title': 'Some of our recent listings include',
  'listings.features.title': 'List on Biconomy for international outreach.',
  'listings.features.1.title': 'Top Exchange',
  'listings.features.1.desc': 'We are a leader in terms of real daily trading volume.',
  'listings.features.2.title': 'Top Coins',
  'listings.features.2.desc': 'We list only top coins and carefully evaluated projects.',
  'listings.features.3.title': 'Top Services',
  'listings.features.3.desc': 'We provide comprehensive pre- and post- listing services',
  'listings.Canadian': 'A Canadian exchange with US SMB license',
  'listings.Contact': 'Contact us now to list your token.',
  'listings.Contact.Telegram':
    'You can contact us directly through Telegram, or you can fill in our listing application form and we’ll get back to you soon.',
  'listings.Telegram': 'Contact through Telegram',
  'listings.Application': 'Application Form',
  'listings.support': 'COMPREHENSIVE STARTUP SUPPORT',
  'listings.we':
    '“We not only provide listing services across our product portfolio, but we also help promote your asset and succeed in the digital world”',
};
